export default __webpack_public_path__ + "static/media/void.4b525d31.png";